import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_failed_to_maintain_any_of_the_following_for_wrkrs_d'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_failed_to_maintain_any_of_the_following_for_wrkrs_d',
  name: 'Has the facility failed to maintain any of the following for workers during and after maternity leave?',
  description:
    'Consult national legislation to determine the period of time following maternity leave to be considered when answering this question.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'EMPLOYMENT_STATUS',
      text: 'Employment status',
      externalIds: [
        {
          id: 'wt-dis-42',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'POSITION',
      text: 'Position',
      externalIds: [
        {
          id: 'wt-dis-43',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WAGES',
      text: 'Wages',
      externalIds: [
        {
          id: 'wt-dis-44',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BENEFITS',
      text: 'Benefits',
      externalIds: [
        {
          id: 'wt-dis-45',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NOT_APPLICABLE',
      text: 'Not Applicable',
      externalIds: [
        {
          id: 'wt-dis-27x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'wt-dis-46',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['EMPLOYMENT_STATUS', 'POSITION', 'WAGES', 'BENEFITS', 'NOT_APPLICABLE', 'NONE_OF_THE_ABOVE'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-dis-41',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11260,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
